// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"c7772d96","318":"dbd461ab","360":"b8728f59","364":"b8728f59","395":"b8728f59","592":"b8728f59","667":"dbd461ab"}[chunkId] + ".chunk.css";
};